import { MediaItem } from "@rapid/types/media";

export const videoUploadProgress = (mediaItem: MediaItem, { elapsed }: { elapsed: number }) => {
    // During upload: animate from 0 to 50% over ~3 seconds
    const uploadAnimationTimeMs = 3000;
    const fakeUploadProgress = Math.min(50, (elapsed / uploadAnimationTimeMs) * 50);
    const actualProgress = mediaItem.progress || 0;
    const newProgress = Math.max(actualProgress, fakeUploadProgress);

    return newProgress;
};

export const videoProcessEstimatedProgress = (
    mediaItem: MediaItem,
    { elapsed }: { elapsed: number }
) => {
    const fileSizeMB = mediaItem.file.size / (1024 * 1024);
    const estimatedProcessingTimeMs = (fileSizeMB / 50) * 4500;
    const processingProgress = Math.min(45, (elapsed / estimatedProcessingTimeMs) * 45);
    const estimatedProgress = 50 + processingProgress;

    return estimatedProgress;
};

export const videoProcessProgress = (
    mediaItem: MediaItem,
    { elapsed, currentProgress }: { elapsed: number; currentProgress: number }
) => {
    // During processing: animate from 50% to 95% based on file size
    const estimatedProgress = videoProcessEstimatedProgress(mediaItem, { elapsed });

    const progressDiff = estimatedProgress - currentProgress;

    const smoothIncrement = Math.max(0.5, Math.abs(progressDiff) * 0.1);

    let newProgress;

    if (progressDiff > 0) {
        newProgress = Math.min(estimatedProgress, currentProgress + smoothIncrement);
    } else {
        newProgress = currentProgress;
    }

    return newProgress;
};
